<div role="alert" class="mb-20 fade">
    <!-- warn-page-alert  info-page-alert  error-page-alert   success-page-alert  -->
  <div class={{alertTheme}}>
    <div class="flex align-center">
      <div class="icon-container">
        <div class="alert-icon">
          <!-- Success Icon -->
          <i class="{{iconclass}}"></i>
          <!-- Warn Icon -->
          <!-- <i class="fas fa-exclamation"></i> -->
  
          <!-- Error Icon -->
          <!-- <i class="fas fa-exclamation"></i> -->
  
          <!-- Info Icon -->
          <!-- <i class="fas fa-info"></i> -->
        </div>
      </div>
      <div class="plr-10 ptb-20">
        <h5 class="semibold">{{alertInfo?.title}}</h5> 
        <p class="alert-page-details">{{alertInfo?.message}}</p>
      </div>
    </div>
    <div class="pr-10">
      <i class="fa fa-lg fa-times" (click)="onCloseAlert()"></i>
    </div>
  </div>
</div>
